import React, { useState, useEffect, useRef } from 'react'
import { getUserData } from '../JwtToken'
import axiosJWT from '../JwtToken'
import socket from './SocketConfig'

const ChatComponent = ({ roomCode, targetUser }) => {
    const [myUserId, setMyUserId] = useState(null)
    const [messages, setMessages] = useState([])
    const [inputMessage, setInputMessage] = useState('')
    const chatContainerRef = useRef(null)

    const scrollToBottom = () => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
        }
    }

    useEffect(() => {
        // Ambil ID user dari token yang sedang aktif
        const userData = getUserData()
        if (userData && userData.id) {
            setMyUserId(userData.id)
        }
    }, [])

    useEffect(() => {
        if (!roomCode) return
        socket.connect()
        socket.emit('join_room', roomCode)

        const markRead = async () => {
            try { await axiosJWT.post('/api/chat/mark-as-read', { roomCode }) } catch (e) { }
        }
        markRead()

        socket.on('receive_message', (newMsg) => {
            setMessages((prev) => [...prev, newMsg])
        })

        socket.on('messages_read_update', (data) => {
            // data.roomCode harus sama, lalu update state messages
            if (data.roomCode === roomCode) {
                setMessages((prev) =>
                    prev.map(m => ({ ...m, isRead: true }))
                )
            }
        })

        return () => {
            socket.emit('leave_room', roomCode)
            socket.off('receive_message')
        }
    }, [roomCode])

    useEffect(() => {
        scrollToBottom()
    }, [messages])

    useEffect(() => {
        const fetchChatHistory = async () => {
            try {
                const response = await axiosJWT.get(`/api/chat/messages/${roomCode}`)
                setMessages(response.data)
            } catch (err) {
                console.error("Gagal load history chat:", err)
            }
        }
        if (roomCode) fetchChatHistory()
    }, [roomCode])

    const handleSendMessage = async (e) => {
        e.preventDefault()
        if (inputMessage.trim() === '') return
        try {
            await axiosJWT.post('/api/chat/send', {
                roomCode, message: inputMessage, targetUser
            })
            setInputMessage('')
        } catch (err) {
            console.error("Gagal kirim chat:", err)
        }
    }

    return (
        <div className="chat-box">
            <div className="chat-header">
                Ruang ({roomCode})
            </div>

            <div className="chat-messages" ref={chatContainerRef}>
                {messages.map((msg, index) => {
                    const isMe = msg.senderPotensialCode === myUserId
                    return (
                        <div key={index} style={{ display: 'flex', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
                            <div className={`chat-bubble ${isMe ? 'msg-me' : 'msg-other'}`}>
                                <p style={{ margin: 0 }}>{msg.message}</p>
                                <span className="msg-time">
                                    {new Date(msg.createdAt).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })}
                                </span>
                                {isMe && (
                                    <span style={{ fontSize: '10px', color: msg.isRead ? '#fffb00' : '#fff' }}>
                                        {msg.isRead ? '✓✓' : '✓'}
                                    </span>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>

            <form onSubmit={handleSendMessage} className="chat-input-form">
                <input
                    type="text"
                    value={inputMessage}
                    onChange={(e) => setInputMessage(e.target.value)}
                    className="chat-input"
                    placeholder="Tulis pesan di sini..."
                />
                <button type="submit" className="chat-btn">Kirim</button>
            </form>
        </div>
    )
}

export default ChatComponent